import axiosInsAcademy from '@/api/axios-ugems-academy.js';
import { GET_COURSE_BY_ID } from '@/api/master-data/course-catalog/course-catalog';

export default {

  getCourses(params) {
    return axiosInsAcademy.get('/tna/partner/completion/courses', { params });
  },

  getCourseDetail(id) {
    return axiosInsAcademy.get(`/tna/partner/completion/courses/${id}/batches`);
  },

  getCourseDetailFromCatalog(id) {
    return GET_COURSE_BY_ID(id);
  },

  submitCompletion(enrollmentId, data) {
    return axiosInsAcademy.post(`/tna/partner/completion/enrollment/${enrollmentId}/submit`, data);
  },

  getCompletionDetail(completionId) {
    return axiosInsAcademy.get(`/tna/partner/completion/${completionId}`);
  },

  submitCompletionReview(completionId, data) {
    return axiosInsAcademy.post(`/tna/partner/completion/${completionId}/review-by-partner-admin`, data);
  },

  bulkUploadCompletion(courseId, formData) {
    return axiosInsAcademy.post(`/tna/partner/completion/${courseId}/bulk`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  
  // Get batch participants with pagination, search, and filter
  getBatchParticipants(batchId, params) {
    return axiosInsAcademy.get(`/tna/partner/completion/batches/${batchId}`, { params });
  },
  
  // Download batch report as Excel
  downloadBatchReport(batchId, params) {
    return axiosInsAcademy.get(`/tna/partner/completion/batches/${batchId}/report`, {
      params,
      responseType: 'blob'
    });
  },

  // Download all certificates as zip
  downloadAllCertificates(batchId, params) {
    return axiosInsAcademy.get(`/tna/partner/completion/batches/${batchId}/certificates`, {
      params,
      responseType: 'blob'
    });
  },
  
 // Get TNA summary statistics
  getSummary(params) {
    return axiosInsAcademy.get('/tna/partner/summary', { params });
  },

};
